export default function Price({ bookingData, handleAmount, isReservePrice }) {
    return (
        <>
            {isReservePrice && (
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>Do you want to reserve?</label>
                    <div className='dropRegInputDiv radioDiv'>
                        <label>
                            <input
                                type='radio'
                                name='isReserved'
                                value='true'
                                checked={bookingData.amountPaid.isReserved === true}
                                onChange={(e) =>
                                    handleAmount(
                                        {
                                            target: {
                                                name: 'isReserved',
                                                value: e.target.value === 'true'
                                            }
                                        },
                                        'amountPaid',
                                        false
                                    )
                                }
                            />
                            Yes
                        </label>

                        <label>
                            <input
                                type='radio'
                                name='isReserved'
                                value='false'
                                checked={bookingData.amountPaid.isReserved === false}
                                onChange={(e) =>
                                    handleAmount(
                                        {
                                            target: {
                                                name: 'isReserved',
                                                value: e.target.value === 'true'
                                            }
                                        },
                                        'amountPaid',
                                        false
                                    )
                                }
                            />
                            No
                        </label>
                    </div>
                </div>
            )}
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Actual Price</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={bookingData.amountPaid.actual}
                        name='actual'
                        onChange={(e) => handleAmount(e, 'amountPaid')}
                        type='Number'
                        placeholder={`Actual amount`}
                        className='dropRegSelect'
                        disabled={true}
                    ></input>
                </div>
            </div>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Tax</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={bookingData.amountPaid.tax}
                        name='tax'
                        onChange={(e) => handleAmount(e, 'amountPaid')}
                        type='Number'
                        placeholder={`Tax`}
                        className='dropRegSelect'
                        disabled={true}
                    ></input>
                </div>
            </div>
            {bookingData.amountPaid.isReserved && (
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>Reserve Price</label>
                    <div className='dropRegInputDiv'>
                        <input
                            value={bookingData.amountPaid.reserve}
                            name='reserve'
                            onChange={(e) => handleAmount(e, 'amountPaid')}
                            type='Number'
                            placeholder={`Reserve amount`}
                            className='dropRegSelect'
                            disabled={true}
                        ></input>
                    </div>
                </div>
            )}
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Total</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={bookingData.amountPaid.total}
                        name='total'
                        onChange={(e) => handleAmount(e, 'amountPaid')}
                        type='Number'
                        placeholder={`Total Amount`}
                        className='dropRegSelect'
                        disabled={true}
                    ></input>
                </div>
            </div>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Paid</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={bookingData.amountPaid.paid || null}
                        name='paid'
                        onChange={(e) => handleAmount(e, 'amountPaid')}
                        type='Number'
                        placeholder={`Amount Paid`}
                        className='dropRegSelect'
                    ></input>
                </div>
            </div>
            {/* <div className='dropRegDiv'>
                <label className='dropRegLabel'>Per Seat</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={bookingData.amountPerSeat}
                        name='amountPerSeat'
                        onChange={(e) => handleChange(e, setBookingData)}
                        type='Number'
                        placeholder={`Amount Per Seat`}
                        className='dropRegSelect'
                        disabled={custom}
                    ></input>
                </div>
            </div> */}
        </>
    );
}
